/* global $:false */
(function() {
  'use strict';

  angular
    .module('admin.publisher.edit', [
    ])
    .controller('PublisherAdminEditCtrl', PublisherAdminEditCtrl);

  /** @ngInject */
  function PublisherAdminEditCtrl($scope, $state, $stateParams, PublisherAdminService, CacheService, UploadService, RoyaltiesAdminService) {
    var vm = this;
    vm.model = {};
    vm.pathImgH = '';
    vm.pathImgT = '';
    vm.id = $stateParams.id;
    vm.loadH = false;
    vm.loadT = false;
    vm.royalties = [];
    vm.types = [
      {
        id: 1,
        title: 'Flat',
      },
      {
        id: 2,
        title: 'Percent',
      }
    ];

    if (vm.id !== "0") {
      PublisherAdminService.get($stateParams.id).then(function(result){
        vm.model = result.results;
        RoyaltiesAdminService.list($stateParams.id).then(function(result){
          var rr = result.results;
          vm.royalties = rr;
        });
      });
    } else {
      vm.model['img-logo-d'] = '';
      vm.model['img-logo-l'] = '';
    }

    vm.save = function(){
      var model = angular.copy(vm.model);
      delete model.ts;
      delete model['ts-p'];
      if (model.t === undefined || model.txt === undefined) {
        swal('Required title and description fields.', '', 'error');
        return;
      }

      if (model.id !== undefined && model.id !== '' && model.id !== 0) {
        PublisherAdminService.update(model.id, model).then(function(){
          $state.go('admin.publishers');
        });
      } else {
        PublisherAdminService.save(model).then(function(){
          $state.go('admin.publishers');
        });
      }
    };

    vm.cancel = function() {
      $state.go('admin.publishers');
    };

    vm.uploadH = function(item){
      vm.loadH = true;
      UploadService.save('publishers', vm.pathImgH, 'img-logo-d', item.id).then(function(fileName){
        vm.loadH = false;
        vm.model['img-logo-d'] = fileName;
      });
    };

    vm.uploadT = function(item){
      vm.loadT = true;
      UploadService.save('publishers', vm.pathImgT, 'img-logo-l', item.id).then(function(fileName){
        vm.loadT = false;
        vm.model['img-logo-l'] = fileName;
      });
    };

    vm.addRoyalty = function() {
      for (var i = 0; i < vm.royalties.length; i++) {
       if (vm.royalties[i].id === 0) {
         swal('You need save a Royalty first', '', 'warning');
         return;
       }
      }

      vm.royalties.push({
        id: 0,
        t: '',
        k: 0,
        amt: 0,
      })
    };

    vm.saveRoyalty = function(item) {
      if (item.t === '' || item.t === null || item.t === undefined) {
        swal('Required title field', '', 'warning');
        return;
      }

      if (item.k === '' || item.k === 0 || item.k === null || item.k === undefined) {
        swal('Required type field', '', 'warning');
        return;
      }

      if (item.amt === '' || item.amt === null || item.amt === undefined) {
        swal('Required amount field', '', 'warning');
        return;
      }

      item.k = parseInt(item.k);
      item['id-pu'] = parseInt(vm.id);

      if (item.id !== 0) {
        RoyaltiesAdminService.update(item.id, item).then(function(result){
          item.id = result.results.id;
          toastr.success('Saved');
        }, function(err){
          swal(err.error.message, '', 'error');
        });
      } else {
        RoyaltiesAdminService.save(vm.id, item).then(function(result){
          item.id = result.results.id;
          toastr.success('Saved');
        }, function(err){
          swal(err.error.message, '', 'error');
        });
      }
    };

    vm.deleteRoyalty = function(item) {
      if (item.id === 0) {
        vm.royalties.remove(item);
        return;
      }

      swal({
        title: "Are you sure?",
        text: "",
        type: "warning",
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: "slide-from-top"
      }, function(isConfirm){
        if (isConfirm){
          RoyaltiesAdminService.remove(item.id).then(function(result){
            vm.royalties.remove(item);
            toastr.success('Deleted');
          }, function(err){
            swal(err.error.message, '', 'error');
          });
        }
      });
    };
  }

})();
